import { Injectable } from "@angular/core";
import { HttpClient } from '@angular/common/http';
import { ChangePasswordModel } from "@app/models/changepasswordmodel";
import { AppSettings } from "@app/common/app-setting";
import { AutharizedEndPointService } from "@app/services/base-service/autharized-endpoint.service";
import { resetPassword } from "@app/models/OTPResult";


@Injectable()
export class ChangePassEndpoint  extends AutharizedEndPointService {
    http1: HttpClient;
    _baseurl = `${AppSettings.API_ENDPOINT}`;

    private readonly _getChangePassUrl: string = 'api/UserManagement/ChangePassword';
    private readonly _getResetPasswordUrl: string = 'api/AccountController/ResetPassword';
    getUrl(url: string) {
        return this._baseurl + url;
    }
    constructor(http: HttpClient) {
        super(http, 'UserManagement/Roles');
        this.http1 = http;
    }
    putPasswordChange(data: ChangePasswordModel) {
         return this.http1.post(this.getUrl(this._getChangePassUrl), data, this.AddAuthToken());
    }

    updatePassword(resetPassword: resetPassword) {
        return this.http1.post(this.getUrl(this._getResetPasswordUrl), resetPassword);
   }
}


// WEBPACK FOOTER //
// ./src/app/services/authentication/change-pass-endpoints.service.ts